import React from 'react';
import { Link } from 'react-router-dom';

class SchoolListItem extends React.Component {
  constructor(props) {
    super(props);

    this.handleToggleRecipient = this.handleToggleRecipient.bind(this);
  }

  handleToggleRecipient() {
    this.props.onToggleRecipient();
  }

  render() {
    const school = this.props.school;
    const smallTextStyle = {
      fontSize: '14px'
    };
    const cellStyle = {
      ...smallTextStyle,
      display: 'block',
      width: '100%',
      maxWidth: '250px',
      overflow: 'auto',

      whiteSpace: 'nowrap'
    };

    return (
      school ? (
        <tr>
          {
            this.props.onToggleRecipient ? (
              <td>
                <input type="checkbox" checked={this.props.hasRecipient} onClick={this.handleToggleRecipient} />
              </td>
            ) : ''
          }
          {/* <td>
            {school.id}
          </td> */}
          <td>
            <p className="mb-1" style={{color: '#999', fontSize: '14px'}}>
              <i className={'fa ' + (school.parent_school_id ? 'fa-school' : 'fa-university') + ' mr-1'}  style={{fontSize: '13px'}} /> {school.type}
            </p>
            <strong><Link to={`/schools/${school.id}/view/`}>{school.name || 'N/D'}</Link></strong><br />
            <span style={{color: '#777'}}>C.M.: {school.id}</span>
          </td>
          <td>
            <span style={smallTextStyle}>
              {school.address}<br />
              {school.postcode} {school.city_name} {school.province_iso_code ? '(' + school.province_iso_code + ')' : ''}<br />
              {school.region_name}
            </span>
          </td>
          <td>
            <span style={cellStyle}><i className="fa fa-phone" /> {school.phone ? <a href={'tel:' + school.phone}>{school.phone}</a> : 'N/D'}</span><br />
            <span style={cellStyle}><i className="fa fa-fax" /> {school.fax || 'N/D'}</span>
          </td>
          <td style={{position: 'relative'}}>
            <span style={cellStyle}><i className="fa fa-envelope" /> {school.email ? <a href={'mailto:' + school.email}>{school.email}</a> : 'N/D'}</span><br />
            <span style={cellStyle}><i className="fa fa-envelope-square" /> {school.certified_email ? <a href={'mailto:' + school.certified_email}>{school.certified_email}</a> : 'N/D'}</span>
          </td>
          {/* <td align="center">{school.num_kits}</td>
          <td align="center">{school.num_teachers}</td> */}
          {/* <td align="center" align="center">
            {
              school.mailings ? (
                <div>
                  <span className="badge badge-info">{school.mailings.num_delivered}</span><br />
                  <span className="badge badge-danger">{school.mailings.num_failed}</span><br />
                  <span className="badge badge-warning">{school.mailings.num_opened}</span><br />
                  <span className="badge badge-success">{school.mailings.num_clicked}</span>
                </div>
              ) : '?'
            }
          </td> */}
          <td>
            {
              school.parent_school ? (
                <div>
                  <strong><Link to={`/schools/${school.parent_school.id}/view/`}>{school.parent_school.name}</Link></strong><br />
                  <span style={{color: '#999'}}>C.M.: {school.parent_school.id}</span>
                </div>
              ) : ''
              }
          </td>
        </tr>
      ) : ''
    );
  }
}

export default SchoolListItem;


// WEBPACK FOOTER //
// ./src/components/schools/SchoolListItem.js